import { render, staticRenderFns } from "./CustomOptionsPicker.vue?vue&type=template&id=32a5dbc5"
import script from "./CustomOptionsPicker.vue?vue&type=script&lang=js"
export * from "./CustomOptionsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a5dbc5')) {
      api.createRecord('32a5dbc5', component.options)
    } else {
      api.reload('32a5dbc5', component.options)
    }
    module.hot.accept("./CustomOptionsPicker.vue?vue&type=template&id=32a5dbc5", function () {
      api.rerender('32a5dbc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom-options-picker/CustomOptionsPicker.vue"
export default component.exports